<div *ngIf="!loading" class="modal-content email-modal">
  <!-- Header -->
  <div class="email-modal__header">
    <div class="email-modal__title">Email preview</div>
    <div class="close-button cross" (click)="closeModal()">
      <img style="height: 24px; width: 24px" src="assets/img/x.svg" alt="" />
    </div>
  </div>

  <!-- Divider under header -->
  <div class="email-modal__divider"></div>

  <div class="modal-body email-modal__body">
    <!-- From / Reply-To row -->
    <div class="email-modal__top-meta">
      <div class="meta-item">
        <div class="meta-label">From:</div>
        <div class="meta-value">
          {{ productType?.emailSender ? productType?.emailSender : 'support@agrisku.com' }}
        </div>
      </div>
      <div class="meta-item">
        <div class="meta-label">Reply-To:</div>
        <div class="meta-value">
          {{ productType?.emailReplyTo ? productType?.emailReplyTo : 'poultry@agrisku.com' }}
        </div>
      </div>
    </div>

    <div class="email-modal__separator"></div>

    <!-- Form Fields -->
    <form class="email-form">
      <!-- To -->
      <div class="email-field">
        <div class="field-label">To:</div>
        <div class="field-control">
          <input id="emailTo" [value]="this.EmailSent.to" disabled class="field-input" />
        </div>
      </div>

      <!-- Cc -->
      <div class="email-field">
        <div class="field-label">Cc:</div>
        <div class="field-control">
          <input id="emailCc" [value]="this.EmailSent.cc" disabled class="field-input" />
        </div>
      </div>

      <!-- Subject -->
      <div class="email-field">
        <div class="field-label">Subject:</div>
        <div class="field-control">
          <input id="subject" [value]="this.EmailSent.subject" disabled class="field-input" />
        </div>
      </div>

      <!-- Email body content -->
      <div class="email-content">
        <div [innerHTML]="this.emailContent"></div>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="email-modal__footer">
    <a (click)="$event.preventDefault(); downloadEmail(this.EmailSent)" href="#" class="btn btn-outline">
      Download Email
    </a>
  </div>
</div>

<div *ngIf="loading" class="spinner-grid-size">
  <ngx-loading
    [show]="loading"
    [config]="{
      backdropBorderRadius: '3px',
      animationType: ngxLoadingAnimationTypes.circle,
      primaryColour: this.primaryColour,
      secondaryColour: this.secondaryColour
    }">
  </ngx-loading>
</div>
